import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import Dialog from '../../common/components/Dialog';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import RecordSubscriptionCancellationForm, { formName, selector } from './RecordSubscriptionCancellationForm';
import { fetchSubscriptionCancellationPreview } from './actions';
import ui from '../../common/services/ui';

class RecordSubscriptionCancellationDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			preview: null
		};
	}

	componentDidUpdate(prevProps) {
		const { show, requestedAt } = this.props;
		// what the cancellation would mean, refreshed when the request date changes
		if (show && (!prevProps.show || requestedAt !== prevProps.requestedAt)) {
			this.loadPreview();
		}
		if (!show && prevProps.show && this.state.preview) {
			this.setState({ preview: null });
		}
	}

	loadPreview() {
		const { paymentId, requestedAt, fetchSubscriptionCancellationPreview } = this.props;
		fetchSubscriptionCancellationPreview(paymentId, requestedAt ? moment(requestedAt).format() : null, preview => this.setState({
			preview: {
				...preview,
				lastDay: ui.formatDate(preview.lastDay),
				owedPayments: preview.owedPayments.map(x => ({ ...x, chargeDate: ui.formatDate(x.chargeDate) }))
			}
		}));
	}

	dialogConfig() {
		const { t, onCancel } = this.props;

		return {
			header: t('PaymentHistory_Subscription_RecordCancellation'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm, cancellationRequestChannels } = this.props;
		return <RecordSubscriptionCancellationForm onSubmit={onConfirm} initialValues={{ requestedAt: new Date() }}
			cancellationRequestChannels={cancellationRequestChannels} preview={this.state.preview} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='danger' formName={formName} label={t('PaymentHistory_Subscription_RecordCancellation')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		return <Dialog config={this.dialogConfig()} show={show} block={block} unblock={unblock} />;
	}
}

RecordSubscriptionCancellationDialog.propTypes = {
	show: PropTypes.bool,
	paymentId: PropTypes.number.isRequired,
	cancellationRequestChannels: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
	block: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string, PropTypes.array, PropTypes.func]),
	unblock: PropTypes.oneOfType([PropTypes.instanceOf(RegExp), PropTypes.string, PropTypes.array, PropTypes.func]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
	requestedAt: selector(state, 'requestedAt')
});

export default connect(mapStateToProps, { fetchSubscriptionCancellationPreview })(withTranslation()(RecordSubscriptionCancellationDialog));
